import { combineEpics, ofType } from "redux-observable";
import { mergeMap, catchError } from "rxjs/operators";
import { of } from "rxjs";
import { observableGET, observablePOST, observablePUT } from "@/api/apiClient";

import {
  getAllChatsRequest,
  getAllChatsSuccess,
  getAllChatsFailure,
  initilizeChatRequest,
  initilizeChatSuccess,
  initilizeChatFailure,
  sendMessageRequest,
  sendMessageFailure,
  getMessageHistoryRequest,
  getMessageHistorySuccess,
  getMessageHistoryFailure,
  upDateSpecificChatList,
  notificationRequest,
  notificationSuccess,
  notificationFailure
} from "./inbox";

const initilizeChatEpic = (action$) => {
  return action$.pipe(
    ofType(initilizeChatRequest.type),
    mergeMap((action) => {
      return observablePOST(`/conversation/initiate-message`, {
        body: action.payload
      }).pipe(
        mergeMap((response) => of(initilizeChatSuccess(response.data))),
        catchError((error) => of(initilizeChatFailure(error)))
      );
    })
  );
};

const getAllConversationsEpic = (action$) => {
  return action$.pipe(
    ofType(getAllChatsRequest.type),
    mergeMap(() => {
      return observableGET(`/conversation/get-all-conversation`).pipe(
        mergeMap((response) => of(getAllChatsSuccess(response.data))),
        catchError((error) => of(getAllChatsFailure(error)))
      );
    })
  );
};

const sendMessageEpic = (action$) => {
  return action$.pipe(
    ofType(sendMessageRequest.type),
    mergeMap((action) => {
      const { message, conversationId } = action.payload;
      const { messageText, sendFromUserId, sendToUserId } = message;
      return observablePOST(`/conversation/add-messages/${conversationId}`, {
        body: { messageText, sendFromUserId, sendToUserId }
      }).pipe(
        mergeMap((response) => {
          of(upDateSpecificChatList(response.data));
        }),
        catchError((error) => of(sendMessageFailure(error)))
      );
    })
  );
};

const getUserSpecificChatEpic = (action$) => {
  return action$.pipe(
    ofType(getMessageHistoryRequest.type),
    mergeMap((action) => {
      const { conversationId } = action.payload;

      return observableGET(
        `/conversation/get-message-history/${conversationId}`
      ).pipe(
        mergeMap((response) => {
          return of(getMessageHistorySuccess(response.data));
        }),
        catchError((error) => of(getMessageHistoryFailure(error)))
      );
    })
  );
};

const getAllNotificationEpic = (action$) => {
  return action$.pipe(
    ofType(notificationRequest.type),
    mergeMap((action) => {
      const { notificationId } = action.payload || {};

      if (notificationId) {
        return observablePUT(
          `/notification/alert/mark-as-read/${notificationId}`
        ).pipe(
          mergeMap(() => {
            return of(notificationRequest());
          }),
          catchError((error) =>
            of(notificationFailure({ message: error?.response?.data?.details }))
          )
        );
      } else {
        return observableGET(`/notification/alert`).pipe(
          mergeMap((response) => {
            return of(notificationSuccess(response.data));
          }),
          catchError((error) =>
            of(notificationFailure({ message: error?.response?.data?.details }))
          )
        );
      }
    })
  );
};

const inboxEpic = combineEpics(
  initilizeChatEpic,
  getAllConversationsEpic,
  sendMessageEpic,
  getUserSpecificChatEpic,
  getAllNotificationEpic
);

export default inboxEpic;
